const m = require('mithril');
const BasePlugin = require('./basePlugin');
const { createTempSvgElement, addLocationMetaInfoToSVGElement, getFeatureUid, processGeoJSON } = require('../mapUtils');
const edit = require('../../layout/components/edit');
const loaders = require('../../layout/components/loaders');
const { LOCATION_STYLES }  = require('../locationConfigs');

class PlaceBuildingPlugin extends BasePlugin {
  constructor(ctrl) {
    super(ctrl);

    this.activeRecord = function () {
      return (this.ctrl.equipmentRecord && this.ctrl.equipmentRecord()) ? this.ctrl.equipmentRecord() : this.ctrl.location();
    }
    
    this.ctrl.eventBus.once('mithril:oncreate', () => {
      // Create the custom control
      this.placeBuildingControl = this.ctrl.map.pm.Toolbar.copyDrawControl("Marker", {
        name: 'placeSVG',
        block: 'edit',
        className: 'leaflet-pm-icon-building',
        title: 'Place Building Outline',
        actions: [{text: 'Cancel', onClick: () => {this.ctrl.map.pm.disableDraw('placeSVG')}}],
        afterClick: this.handlePlaceBuildingButtonClicked,
        afterCancel: () => {
          this.ctrl.map.disableDraw('placeSVG');
        },
        disabled: false
      })
    });

    this.ctrl.eventBus.on('mithril:onupdate', () => {
      //Add or remove the control based on editing state and location type
      if (this.activeRecord()?.svg) {
        this.ctrl.map.pm.Toolbar.setButtonDisabled('placeSVG', false)
      } else {
        this.ctrl.map.pm.Toolbar.setButtonDisabled('placeSVG', true)
      }
    });
  }
  
  handlePlaceBuildingButtonClicked = (e) => {
    this.ctrl.map.pm.enableDraw('Rectangle');
    this.ctrl.map.pm.disableDraw('Rectangle');
    // Enable point draw
    this.ctrl.map.pm.enableDraw('placeSVG', {
      markerStyle: {
        icon: new L.icon({
          iconUrl: '/images/marker-icon.png', 
          shadowUrl: '/images/marker-shadow.png', 
          iconSize: [25, 41], 
          iconAnchor: [12, 41]
        })
      }
    });
    this.ctrl.map.once('pm:create', this.handleSVGPlacement);
  }

  handleSVGPlacement = async (e) => {
    const placementPoint = e.layer.getLatLng();
    e.layer.remove();
    const svgString = this.activeRecord().svg;
    const svgElement = createTempSvgElement(svgString);

    addLocationMetaInfoToSVGElement(svgElement, placementPoint);
    const svgMetaInfo = svgElement.querySelector('MetaInfo');
    const geo = svgMetaInfo.querySelector('Geo');
    const corners = geo.querySelectorAll('GeoItem');
    const bounds = L.latLngBounds(
      [corners[0].getAttribute('Latitude'), corners[0].getAttribute('Longitude')], 
      [corners[1].getAttribute('Latitude'), corners[1].getAttribute('Longitude')]
    );
    this.ctrl.map.flyToBounds(bounds, { padding: [40, 40], duration: 0.8 }); // Padding is in pixels
    // Serialize the SVG element back to a string
    let serializer = new XMLSerializer();
    let updatedSVGString = serializer.serializeToString(svgElement);
    let url = `/api/v1/location/placeoutline/${this.activeRecord()['@rid'].slice(1)}`;

    // PUT 
    let response = await loaders.requestWithLoader({
      method: 'PUT',
      url: url,
      body: {
        svg: updatedSVGString
      }
    });

    this.activeRecord().geojson = JSON.stringify(response)
    this.activeRecord().context = 'this';
    // Emit to remove the existing building outline if present
    this.ctrl.eventBus.emit('featuresToRemove', [getFeatureUid(this.activeRecord())]);
    // Emit to add the new building outline

    this.ctrl.eventBus.emit('featuresToAdd', [this.activeRecord()]);
    this.ctrl.map.flyToBounds(bounds, { padding: [40, 40], duration: 0.8 }); // Padding is in pixels

    this.ctrl.map.pm.disableDraw('placeSVG');
  }

}

module.exports = PlaceBuildingPlugin;
